import React from "react"

import { connect } from "scrivito"

import "./styles/_product-page.scss"
import { ProductPageModel } from "./types/ProductPageModel"
import { ProductPageActions } from "./ui/ProductPageActions"
import { ProductPageAddToProject } from "./ui/ProductPageAddToProject"
import { ProductPageAddonSectionTitle } from "./ui/ProductPageAddonSectionTitle"
import { ProductPageAttributes } from "./ui/ProductPageAttributes"
import { ProductPageBreadcrumb } from "./ui/ProductPageBreadcrumb"
import { ProductPageBuildingReferences } from "./ui/ProductPageBuildingReferences"
import { ProductPageDownloads } from "./ui/ProductPageDownloads"
import { ProductPageExternalDimensioning } from "./ui/ProductPageExternalDimensioning"
import { ProductPageHeader } from "./ui/ProductPageHeader"
import { ProductPageImage } from "./ui/ProductPageImage"
import { ProductPageNavigation } from "./ui/ProductPageNavigation"
import { ProductPageQuickInfos } from "./ui/ProductPageQuickInfos"
import { ProductPageRoot } from "./ui/ProductPageRoot"
import { ProductPageSubTitle } from "./ui/ProductPageSubTitle"
import { ProductPageSummary } from "./ui/ProductPageSummary"
import { ProductPageTenderText } from "./ui/ProductPageTenderText"
import { ProductPageTitle } from "./ui/ProductPageTitle"

const ProductPage = {
  Root: ProductPageRoot,
  Breadcrumb: ProductPageBreadcrumb,
  Header: ProductPageHeader,
  Title: ProductPageTitle,
  SubTitle: ProductPageSubTitle,
  Image: ProductPageImage,
  AddToProject: ProductPageAddToProject,
  Summary: ProductPageSummary,
  QuickInfos: ProductPageQuickInfos,
  Downloads: ProductPageDownloads,
  TenderText: ProductPageTenderText,
  Attributes: ProductPageAttributes,
  ExternalDimensioning: ProductPageExternalDimensioning,
  AddonSectionTitle: ProductPageAddonSectionTitle,
  Navigation: ProductPageNavigation,
  Actions: ProductPageActions,
  BuildingReferences: ProductPageBuildingReferences
}

export interface ProductPageProps extends ProductPageModel {}

function ProductPageComponent(props: ProductPageProps) {
  const {
    productType,
    productObj,
    productBaseVariantObj,
    productData,
    isAuthenticated
  } = props
  const productInformation = productData.productInformation?.data

  const title = productData.productInformation?.isLoading
    ? productBaseVariantObj?.get("title") || productObj?.get("title")
    : productInformation?.title

  return (
    <ProductPage.Root {...props}>
      <ProductPage.Breadcrumb />
      <div className="product-page__side card card--elevated">
        <ProductPage.Header>
          <ProductPage.Title />
          <ProductPage.SubTitle />
        </ProductPage.Header>
        <ProductPage.Navigation />
        <div className="product-page__side-footer">
          <ProductPage.Actions />
        </div>
      </div>

      <div className="product-page__main">
        <div
          id="product-main"
          className="product-page__product-section product-page__main-product"
        >
          <div className="product-page__mobile-header product-page__section card card--elevated">
            <ProductPage.Header>
              <ProductPage.Title />
              <ProductPage.SubTitle />
            </ProductPage.Header>
            <ProductPage.Image />
          </div>
          <ProductPage.Summary id="product-summary" />
          <div className="product-page__product-section">
            <h2 className="product-page__product-section-title">{title}</h2>
            <ProductPage.QuickInfos
              id="product-information"
              productType={productType}
            />
            <ProductPage.Downloads
              id="product-downloads"
              productType={productType}
            />
            <ProductPage.TenderText
              id="product-tender-text"
              productInformation={productInformation}
              isLoading={productData.productInformation?.isLoading}
            />
            <ProductPage.Attributes
              id="product-attributes"
              productInformation={productInformation}
              isLoading={productData.productInformation?.isLoading}
            />
            <ProductPage.ExternalDimensioning
              id="product-external-dimensioning"
              productInformation={productInformation}
              isLoading={productData.productInformation?.isLoading}
            />
            <ProductPage.BuildingReferences id="product-building-references" />
          </div>
        </div>
        {productInformation?.addons?.map((addonInformation, index) => (
          <div
            id={`addon-${index + 1}-information`}
            className="product-page__addon product-page__product-section"
            key={addonInformation.variantKey}
          >
            <ProductPage.AddonSectionTitle
              productInformation={addonInformation}
            />
            <ProductPage.QuickInfos
              productType={addonInformation.productType}
              parentProductType={productType}
            />
            <ProductPage.Downloads
              productType={addonInformation.productType}
              parentProductType={productType}
            />
            <ProductPage.TenderText productInformation={addonInformation} />
            <ProductPage.Attributes productInformation={addonInformation} />
          </div>
        ))}
        {isAuthenticated ? (
          <div className="product-page__footer">
            <ProductPage.AddToProject />
          </div>
        ) : null}
      </div>
    </ProductPage.Root>
  )
}

export const ProductPageDefault = React.memo(
  connect(ProductPageComponent)
) as typeof ProductPageComponent
